
import TownLayer from './parts/TownLayer';
import BulletLayer from './parts/BulletLayer';
import { EVENTS } from '../../../shared/Events';
import ConfigScene from '../../helpers/ConfigScene';
import Clock from './parts/Clock';

class Town extends PIXI.Container {
  constructor() {
    super();

    // parts
    this.bulletsCont = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // props
    this.y = ConfigScene.SIZES.SCENE_CONT_HEIGHT - ConfigScene.SIZES.SCENE_ACTIVE_HEIGHT;

    // clock - just sound handler
    new Clock();

    // containers
    const layersCont = new PIXI.Container();
    this.addChild(layersCont);

    this.bulletsCont = new PIXI.Container();
    this.addChild(this.bulletsCont);

    // set layers
    for (let i = 0; i <= 3; i += 1) {
      layersCont.addChild(new TownLayer(i));
      this.bulletsCont.addChild(new BulletLayer(i));
    }

    // signals
    aScene.signals.sceneCallMain.add(this.callMainFc, this);
  }

  showBullets(doShow) {
    TweenMax.killTweensOf(this.bulletsCont);
    TweenMax.to(this.bulletsCont, 0.6, {
      alpha: doShow ? 1 : 0,
    });
  }

  // --------------------------------------------------------------
  // Main Call
  // --------------------------------------------------------------

  callMainFc(sgType) {
    switch (sgType) {
      case EVENTS.MOVE_TO_HEAVEN_START:
        this.showBullets(false);
        break;
      case EVENTS.MOVE_TO_TOWN_END:
        this.showBullets(true);
        break;
      case EVENTS.MOVE_TO_TOWN_START:
        this.visible = true;
        break;
      case EVENTS.MOVE_TO_HEAVEN_END:
        this.visible = false;
        break;
      default:
    }
  }
}

export default Town;



// WEBPACK FOOTER //
// ./src/js/scene/parts/town/Town.js